import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit'
import userSlice from './collections/user';
import closetCartSlice from './collections/closetCart';

export default () => {
    const store = configureStore({
        reducer: combineReducers({
            user: userSlice.reducer,
            closetCart: closetCartSlice.reducer,
        })
    });
    return store;
};

